import { i as p, x as m, s as c } from "../../../lit-element-6iugfgmM.js";
import { e as b } from "../../../custom-element-wk-AooBb.js";
import { n as r } from "../../../property-BWlAHqg_.js";
import { t as u } from "../../../state-STZTbIJp.js";
import { i as y } from "../../../query-D8_rwLua.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-button-fa52iiKJ.js";
import "../../../sp-dialog-C9swJ4nV.js";
import "../../../sp-dialog-base-CHozb5nU.js";
import "../../../sp-help-text-BIQyunk0.js";
import "../../../sp-textfield-DUJtyE8s.js";
import g from "../../../events/EditLibraryNameEvent.js";
import h from "../../../events/NotificationEvent.js";
import { Analytics as f } from "../../../lib/Analytics.js";
import { Localize as v } from "../../../lib/I18N.js";
import { b as N, p as x } from "../../../Libraries-BoeFPC98.js";
const _ = { "edit-library-dialog.error": "There was a problem updating the library name. Please try again later.", "edit-library-dialog.label.cancel": "Cancel", "edit-library-dialog.label.save": "Save", "edit-library-dialog.library-name-error": 'The library name may be up to 255 characters long. It cannot be blank, end with a period or space, or contain any of the following: / * ? \\ " | : < >', "edit-library-dialog.success": "Edits saved", "edit-library-dialog.title": "Edit library name", "edit-library-dialog.undo": "Undo" }, w = p`:host{--mod-textfield-border-color: var(--spectrum-gray-500);--mod-textfield-border-width: 2px;--mod-textfield-font-weight: 700;--mod-textfield-placeholder-font-size: 24px;--mod-textfield-width: 100%}sp-textfield:focus{--mod-textfield-border-color: none}`;
var $ = Object.defineProperty, E = Object.getOwnPropertyDescriptor, i = (t, s, l, o) => {
  for (var n, a = o > 1 ? void 0 : o ? E(s, l) : s, d = t.length - 1; d >= 0; d--) (n = t[d]) && (a = (o ? n(s, l, a) : n(a)) || a);
  return o && a && $(s, l, a), a;
};
let e = class extends f(v(c, _)) {
  constructor() {
    super(...arguments), this.currentName = "", this.previousName = "", this.open = !1, this.disabled = !1, this.libraryId = "", this.newName = "", this.invalid = !1, this.pattern = N(), this._undoLibraryNameUpdate = async () => {
      this.currentName = this.previousName, this.newName = this.currentName, this._resetTextfieldValue(), await this._handleSave();
    };
  }
  static get styles() {
    return w;
  }
  render() {
    return m`<sp-dialog-base underlay dismissable .open="${this.open}" @close="${this._handleClose}"><sp-dialog size="m" no-divider aria-labelledby="dialog-heading"><span slot="heading">${this.t("edit-library-dialog.title")}</span><sp-textfield label="${this.t("edit-library-dialog.title")}" maxlength="${255}" minlength="${1}" quiet value="${this.currentName}" @input="${this._handleNameChange}" ?invalid="${this.invalid}"><sp-help-text slot="negative-help-text" variant="negative">${this.invalid ? this._showNameErrorMessage() : ""}</sp-help-text></sp-textfield><sp-button slot="button" variant="secondary" treatment="outline" @click="${this._handleCancel}">${this.t("edit-library-dialog.label.cancel")}</sp-button><sp-button id="save-button" slot="button" ?disabled="${this.disabled}" @click="${this._handleSave}">${this.t("edit-library-dialog.label.save")}</sp-button></sp-dialog></sp-dialog-base>`;
  }
  _handleNameChange(t) {
    this.newName = t.target.value;
  }
  _checkNamePattern() {
    if (this.textfield.value === this.currentName) return void (this.invalid = !1);
    const t = this.pattern.test(this.newName);
    this.invalid = !t;
  }
  _handleCancel() {
    this._handleClose(), this._resetTextfieldValue();
  }
  _handleClose() {
    this.open = !1, this.invalid = !1, this.dispatchEvent(new Event("close", { bubbles: !0, composed: !0 }));
  }
  async _handleSave() {
    if (this._checkNamePattern(), !this.invalid) return this.disabled = !0, x(this.libraryId, { name: this.newName }).then(() => {
      this.previousName = this.currentName, this.currentName = this.newName, this.dispatchEvent(new g(this.newName)), this._sendSuccessNotification(), this._handleClose();
    }).catch((t) => {
      t.status !== 400 ? (this.handleApiError(t, "libraries"), this._sendErrorNotification(), this._handleCancel()) : this.invalid = !0;
    }).finally(() => {
      this.disabled = !1;
    });
  }
  _sendSuccessNotification() {
    this.dispatchEvent(new h({ type: "success", message: this.t("edit-library-dialog.success"), options: { actionLabel: this.t("edit-library-dialog.undo"), callbackAction: this._undoLibraryNameUpdate } }));
  }
  _sendErrorNotification() {
    this.dispatchEvent(new h({ type: "error", message: this.t("edit-library-dialog.error") }));
  }
  _showNameErrorMessage() {
    return this.t("edit-library-dialog.library-name-error");
  }
  _resetTextfieldValue() {
    this.textfield.value = this.currentName;
  }
};
i([r({ type: String })], e.prototype, "currentName", 2), i([r({ type: String })], e.prototype, "previousName", 2), i([r({ type: Boolean })], e.prototype, "open", 2), i([r({ type: Boolean })], e.prototype, "disabled", 2), i([r({ type: String })], e.prototype, "libraryId", 2), i([r({ type: String })], e.prototype, "newName", 2), i([y("sp-textfield")], e.prototype, "textfield", 2), i([u()], e.prototype, "invalid", 2), e = i([b("af-edit-library-dialog")], e);
const D = e;
export {
  D as default
};
//# sourceMappingURL=EditLibraryDialog.js.map
